import { render, staticRenderFns } from "./content-title.vue?vue&type=template&id=b0796fca&"
import script from "./content-title.vue?vue&type=script&lang=js&"
export * from "./content-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./content-title.vue?vue&type=custom&index=0&blockType=s&lang=less&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports